import { useEffect, useState } from 'react'

export const OFFER_SECONDS = 17 * 60 + 34 // 00:17:34

export type TimeLeft = {
  hours: string
  minutes: string
  seconds: string
}

function format(total: number): TimeLeft {
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const seconds = total % 60
  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }
}

/**
 * Counts down from 00:17:34 and automatically restarts when it reaches zero.
 */
export function useCountdown(startSeconds: number = OFFER_SECONDS): TimeLeft {
  const [remaining, setRemaining] = useState(startSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? startSeconds : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [startSeconds])

  return format(remaining)
}
